/* eslint-disabled */
import Voucher from "./Voucher";
import VoucherGroupExtend from "@/entity/extends/VoucherGroupExtend";
import { hydrateCollection } from "@/Utils/EntityHelper";

export default class VoucherGroup extends VoucherGroupExtend {

public id!: number;
public name = '';
public description? = '';
public vouchers: Array<Voucher> = [];

  constructor (object?: any) {
      super(object)
      if(object){
       this.id= object.id;
       this.name= object.name;
       this.description= object.description;
            hydrateCollection(object.vouchers, Voucher, this.vouchers);
      }
      this.postConstruct()
  }

}
